<div class="visor-documento-root">
  
    <!-- Estado -1: Cargando información -->
    <div class="row" id="documentoCarga" *ngIf="estado == -1">
      <div id="Loading" style="padding: 40px 20px;">
        <div class="alert alert-info" role="alert" id="rectangulo">
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div id="carga1">Estamos cargando la información</div>
          <div id="carga2">Por favor, espera un momento.</div>
        </div>
      </div>
    </div>
  
    <!-- Estado 2 + ADO 1/14/2: Validando -->
    <div class="row" id="documentoCarga" *ngIf="estado == 2 && (estadoADO == 1 || estadoADO == 14 || estadoADO==2)">
      <div id="Loading" style="padding: 40px 20px;">
        <div class="alert alert-success" role="alert" id="rectangulo">
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div id="carga1">Estamos validando la información</div>
          <div id="carga2">Por favor, espera un momento.</div>
        </div>
      </div>
    </div>
  
    <!-- Estado 1 o 0: Documento no disponible -->
    <div class="row" id="documento" *ngIf="estado == 1 || estado == 0">
      <div class="col-md-12">
        <div class="tarjeta-no-disponible">
          <div class="icono-circular">
            <svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M7 3H14L19 8V20H7Z" stroke="#1D3C34" />
              <path d="M14 3V8H19" stroke="#1D3C34" />
              <path d="M9.5 12.5H15" stroke="#00966C" />
              <path d="M9.5 15.5H15" stroke="#00B0B9" />
            </svg>
          </div>
          <h2 class="titulo">El documento no está disponible para firma</h2>
          <p class="subtitulo">Verifica el enlace o vuelve a intentarlo más tarde.</p>
        </div>
      </div>
    </div>
  
    <!-- Estado 2 + ADO 0: Vista normal del documento -->
    <div class="row" id="documentoVista" *ngIf="estado == 2 && estadoADO == 0">
  
      <!-- ══════ PANEL IZQUIERDO ══════ -->
      <div class="col-md-5">
        <div class="left-panel-content">
        <!-- Topbar con logo y fecha -->
        <div class="left-topbar">
          <div class="brand-logo">
            <img src="../../assets/img/Logo Apertu claro.svg" alt="Apertú" />
          </div>
          <div class="badge-date">
            <strong>Firma de documentos</strong>
          </div>
        </div>
  
        <!-- Hero con imagen -->
        <div class="left-hero">
          <img class="hero-photo" src="../../assets/img/Grupo 633.svg" alt="Persona revisando documento" />
        </div>
  
        <!-- Barra de pasos -->
        <div class="steps-bar">
          <p class="steps-bar-heading">Lee el documento a continuación para conocer<br> y verificar la información</p>
          <ol id="barra-simples-1" class="small step-progress-bar">
            <li class="step-present" style="width: 33.3333%; z-index: 3;">
              <span class="content-bullet">1</span>
              <div id="img1"><img id="F1" src="../../assets/img/paso-terminos.svg"></div>
              <span class="content-wrapper">Lectura de términos<br>y condiciones</span>
            </li>
            <li class="step-present" style="width: 33.3333%; z-index: 2;">
              <span class="content-bullet">2</span>
              <div id="img2"><img id="F2" src="../../assets/img/paso-lectura.svg"></div>
              <span class="content-wrapper">Lectura de<br> documento</span>
              <span class="content-stick step-future"></span>
            </li>
            <li class="step-future" style="width: 33.3333%; z-index: 1;">
              <span class="content-bullet">3</span>
              <div id="img3"><img id="F3" src="../../assets/img/paso-identidad.svg"></div>
              <span class="content-wrapper">Validación de identidad <br>y firma de documentos</span>
              <span class="content-stick step-future"></span>
            </li>
          </ol>
        </div>
  
        <!-- Cuerpo: aceptación + botón (desktop) -->
        <div class="left-body">
          <div class="aceptacion">
            Tu aceptación es equivalente a la firma en el acuerdo, según lo establecido por la Ley No. 527 de 1999,
            mediante la cual se define y regula el acceso y uso de los mensajes de datos. No es necesario imprimir o
            descargar los documentos.
          </div>
          <div id="boton" class="d-none d-lg-block">
            <button (click)="tokenUrl()" class="bFirma">Continuar para firmar</button>
          </div>
        </div>
  
        <!-- Footer de contacto -->
        <div class="left-footer">
          <div class="footer-grid">
            <img class="footer-logo" src="../../assets/img/LogoPestana.svg" alt="Apertú" />
            <div class="footer-col">
              <h6>Línea atención Bogotá</h6>
              <p>(601) 744 2484</p>
            </div>
            <div class="footer-col">
              <h6>Línea gratuita nacional</h6>
              <p>018000 113 881</p>
            </div>
            <div class="footer-col">
              <h6>Síguenos</h6>
              <div class="footer-social">
                <a href="https://www.facebook.com/share/1CaC2yg8Ju/?mibextid=wwXIfr" aria-label="Facebook"><img src="../../assets/img/facebook.svg" alt="" /></a>
                <a href="https://www.instagram.com/bayportcolombia?igsh=b3o1Mmt2bXd6Yno0" aria-label="Instagram"><img src="../../assets/img/instagram.svg" alt="" /></a>
                <a href="https://youtube.com/@bayportcolombiaoficial?si=oVOP0Gmuy5e-Cw-x" aria-label="YouTube"><img src="../../assets/img/youtube.svg" alt="" /></a>
                <a href="https://www.linkedin.com/company/bayportcolombia/" aria-label="LinkedIn"><img src="../../assets/img/LinkedIn.svg" alt="" /></a>
                <a href="https://x.com/bayportcolombia?s=21" aria-label="X"><img src="../../assets/img/x.svg" alt="" /></a>
              </div>
            </div>
          </div>
          <p class="footer-disclaimer">
            Las llamadas desde celular deben realizarse a la línea de atención en Bogotá.
            Las llamadas desde teléfono fijo fuera de Bogotá, deben realizarse a la línea de atención nacional.
          </p>
        </div>
        <div class="left-footer-legal">
          <p class="footer-url">www.apertu.com.co</p>
          <p class="footer-copy">© Apertú Colombia S.A. Todos los derechos reservados</p>
        </div>
        </div>
  
        <!-- Botón mobile -->
        <div class="row d-block d-lg-none" style="padding: 12px 24px 20px;">
          <div class="col-md-12" id="boton">
            <button (click)="tokenUrl()" class="bFirma">Continuar para firmar</button>
          </div>
        </div>
      </div>
      <!-- ══════ FIN PANEL IZQUIERDO ══════ -->
  
      <!-- Panel derecho: PDF viewer — SIN CAMBIOS -->
      <div class="col-xs-12 col-md-7">
        <div id="outerContainer">
          <div class="pdf-container">
            <pdf-viewer [src]="src" [rotation]="4" [original-size]="false" [show-all]="true" [fit-to-page]="true"
              [zoom]="0" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
              [external-link-target]="'blank'" [autoresize]="true" [show-borders]="true"
              style="width: 100%; height: 100%;"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Estado 2 + ADO distinto (error de firma) -->
    <div class="row" id="documentoVista" *ngIf="estado == 2 && !(estadoADO == 0 || estadoADO == 1 || estadoADO == 14 || estadoADO==2)">
  
      <div class="col-md-5">
        <div class="left-panel-content">
        <!-- Topbar -->
        <div class="left-topbar">
          <div class="brand-logo">
            <img src="../../assets/img/Logo Apertu claro.svg" alt="Apertú" />
          </div>
          <div class="badge-date">
            <strong>Firma de documentos</strong>
          </div>
        </div>
  
        <!-- Alerta de error + hero (sin espacio entre ambos) -->
        <div class="left-firma-error-block">
          <div class="alert alert-danger" role="alert">
            <img src="../../assets/img/error.svg" id="imgError" alt="" />
            <p class="alert-danger-text">
              La firma de documentos no fue exitosa, vuelve a intentarlo siguiendo adecuadamente las instrucciones.
              Haz clic en <b>Continuar para firmar.</b>
            </p>
          </div>
          <div class="left-hero">
            <img class="hero-photo" src="../../assets/img/mensajeError.svg" alt="Error al firmar" />
          </div>
        </div>
  
        <!-- Steps bar -->
        <div class="steps-bar">
          <p class="steps-bar-heading">Lee el documento a continuación para conocer y verificar la información</p>
          <ol id="barra-simples-1" class="small step-progress-bar">
            <li class="step-present" style="width: 33.3333%; z-index: 3;">
              <span class="content-bullet">1</span>
              <div id="img1"><img id="F1" src="../../assets/img/paso-terminos.svg"></div>
              <span class="content-wrapper">Lectura de términos<br>y condiciones</span>
            </li>
            <li class="step-present" style="width: 33.3333%; z-index: 2;">
              <span class="content-bullet">2</span>
              <div id="img2"><img id="F2" src="../../assets/img/paso-lectura.svg"></div>
              <span class="content-wrapper">Lectura de<br> documento</span>
            </li>
            <li class="step-future" style="width: 33.3333%; z-index: 1;">
              <span class="content-bullet">3</span>
              <div id="img3"><img id="F3" src="../../assets/img/paso-identidad.svg"></div>
              <span class="content-wrapper">Validación de identidad <br>y firma de documentos</span>
            </li>
          </ol>
        </div>
  
        <div class="left-body">
          <div class="aceptacion">
            Tu aceptación es equivalente a la firma en el acuerdo, según lo establecido por la Ley No. 527 de 1999,
            mediante la cual se define y regula el acceso y uso de los mensajes de datos. No es necesario imprimir o
            descargar los documentos.
          </div>
          <div id="boton" class="d-none d-lg-block">
            <button (click)="tokenUrl()" class="bFirma">Continuar para firmar</button>
          </div>
        </div>
  
        <!-- Footer -->
        <div class="left-footer">
          <div class="footer-grid">
            <img class="footer-logo" src="../../assets/img/LogoPestana.svg" alt="Apertú" />
            <div class="footer-col"><h6>Línea atención Bogotá</h6><p>(601) 744 2484</p></div>
            <div class="footer-col"><h6>Línea gratuita nacional</h6><p>018000 113 881</p></div>
            <div class="footer-col">
              <h6>Síguenos</h6>
              <div class="footer-social">
                <a href="https://www.facebook.com/share/1CaC2yg8Ju/?mibextid=wwXIfr" aria-label="Facebook"><img src="../../assets/img/facebook.svg" alt="" /></a>
                <a href="https://www.instagram.com/bayportcolombia?igsh=b3o1Mmt2bXd6Yno0" aria-label="Instagram"><img src="../../assets/img/instagram.svg" alt="" /></a>
                <a href="https://youtube.com/@bayportcolombiaoficial?si=oVOP0Gmuy5e-Cw-x" aria-label="YouTube"><img src="../../assets/img/youtube.svg" alt="" /></a>
                <a href="https://www.linkedin.com/company/bayportcolombia/" aria-label="LinkedIn"><img src="../../assets/img/LinkedIn.svg" alt="" /></a>
                <a href="https://x.com/bayportcolombia?s=21" aria-label="X"><img src="../../assets/img/x.svg" alt="" /></a>
              </div>
            </div>
          </div>
          <p class="footer-disclaimer">Las llamadas desde celular deben realizarse a la línea de atención en Bogotá. 
                                       Las llamadas desde teléfono fijo fuera de Bogotá, deben realizarse a la línea de atención nacional.</p>
        </div>
        <div class="left-footer-legal">
          <p class="footer-url">www.apertu.com.co</p>
          <p class="footer-copy">© Apertú Colombia S.A. Todos los derechos reservados</p>
        </div>
        </div>
  
        <div class="row d-block d-lg-none" style="padding: 12px 24px 20px;">
          <div class="col-md-12" id="boton">
            <button (click)="tokenUrl()" class="bFirma">Continuar para firmar</button>
          </div>
        </div>
      </div>
  
      <!-- Panel derecho PDF — SIN CAMBIOS -->
      <div class="col-md-7">
        <div id="outerContainer">
          <div class="pdf-container">
            <pdf-viewer [src]="src" [rotation]="4" [original-size]="false" [show-all]="true" [fit-to-page]="true"
              [zoom]="0" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
              [external-link-target]="'blank'" [autoresize]="true" [show-borders]="true"
              style="width: 100%; height: 100%;"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Estado 3: Firma completada -->
    <div class="row" id="documentoFirma" *ngIf="estado == 3">
  
      <!-- src2 vacío: esperando documento firmado -->
      <div class="col-md-5" *ngIf="estado == 3 && src2 == ''">
        <div class="left-panel-content">
        <div class="left-topbar">
          <div class="brand-logo">
            <img src="../../assets/img/Logo Apertu claro.svg" alt="Apertú" />
          </div>
          <div class="badge-date">
            <strong>Firma de documentos</strong>
          </div>
        </div>
  
        <div class="left-firma-success-block">
          <div class="alert alert-success" role="alert">
            <img src="../../assets/img/correcto.svg" id="imgCorrecto" alt="" />
            <p class="alert-success-text">La firma de documentos fue exitosa.</p>
          </div>
          <div class="left-hero">
            <img class="hero-photo" src="../../assets/img/documentoFirmado.svg" alt="Documento firmado" />
          </div>
        </div>
  
        <div class="steps-bar">
          <p class="steps-bar-heading">A continuación puedes descargar tu documento firmado</p>
          <ol id="barra-simples-1" class="small step-progress-bar">
            <li class="step-present" style="width: 33.3333%; z-index: 3;">
              <span class="content-bullet">1</span>
              <div id="img1"><img id="F1" src="../../assets/img/paso-terminos.svg"></div>
              <span class="content-wrapper">Lectura de términos<br>y condiciones</span>
            </li>
            <li class="step-present" style="width: 33.3333%; z-index: 2;">
              <span class="content-bullet">2</span>
              <div id="img2"><img id="F2" src="../../assets/img/paso-lectura.svg"></div>
              <span class="content-wrapper">Lectura de<br> documento</span>
            </li>
            <li class="step-present" style="width: 33.3333%; z-index: 1;">
              <span class="content-bullet">3</span>
              <div id="img3"><img id="F3" src="../../assets/img/paso-identidad.svg"></div>
              <span class="content-wrapper">Validación de identidad <br>y firma de documentos</span>
            </li>
          </ol>
        </div>
  
        <div class="left-body">
          <div class="aceptacion">
            Tu aceptación es equivalente a la firma en el acuerdo, según lo establecido por la Ley No. 527 de 1999,
            mediante la cual se define y regula el acceso y uso de los mensajes de datos. No es necesario imprimir o
            descargar los documentos.
          </div>
          <div id="boton">
            <button class="bFirma1" disabled>Descargar documento</button>
          </div>
        </div>
  
        <div class="left-footer">
          <div class="footer-grid">
            <img class="footer-logo" src="../../assets/img/LogoPestana.svg" alt="Apertú" />
            <div class="footer-col"><h6>Línea atención Bogotá</h6><p>(601) 744 2484</p></div>
            <div class="footer-col"><h6>Línea gratuita nacional</h6><p>018000 113 881</p></div>
            <div class="footer-col">
              <h6>Síguenos</h6>
              <div class="footer-social">
                <a href="https://www.facebook.com/share/1CaC2yg8Ju/?mibextid=wwXIfr" aria-label="Facebook"><img src="../../assets/img/facebook.svg" alt="" /></a>
                <a href="https://www.instagram.com/bayportcolombia?igsh=b3o1Mmt2bXd6Yno0" aria-label="Instagram"><img src="../../assets/img/instagram.svg" alt="" /></a>
                <a href="https://youtube.com/@bayportcolombiaoficial?si=oVOP0Gmuy5e-Cw-x" aria-label="YouTube"><img src="../../assets/img/youtube.svg" alt="" /></a>
                <a href="https://www.linkedin.com/company/bayportcolombia/" aria-label="LinkedIn"><img src="../../assets/img/LinkedIn.svg" alt="" /></a>
                <a href="https://x.com/bayportcolombia?s=21" aria-label="X"><img src="../../assets/img/x.svg" alt="" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="left-footer-legal">
          <p class="footer-url">www.apertu.com.co</p>
          <p class="footer-copy">© Apertú Colombia S.A. Todos los derechos reservados</p>
        </div>
        </div>
      </div>
  
      <div class="col-xs-12 col-md-7" *ngIf="estado == 3 && src2 == ''">
        <div>
          <img src="../../assets/img/pdfFondo.png" id="pdfPrueba">
        </div>
        <br><br><br><br><br><br><br><br>
        <div id="Loading">
          <div class="alert alert-info" role="alert" id="rectangulo">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div id="carga1">Estamos cargando tu documento</div>
            <div id="carga2">Por favor, espera un momento. Este proceso puede tomar aproximadamente 3 minutos</div>
          </div>
        </div>
      </div>
  
      <!-- src2 con contenido: documento firmado listo -->
      <div class="col-md-5"  *ngIf="estado == 3 && src2 != ''">
        <div class="left-panel-content">
        <div class="left-topbar">
          <div class="brand-logo">
            <img src="../../assets/img/Logo Apertu claro.svg" alt="Apertú" />
          </div>
          <div class="badge-date">
            <strong>Firma de documentos</strong>
          </div>
        </div>
  
        <div class="left-firma-success-block">
          <div class="alert alert-success" role="alert">
            <img src="../../assets/img/correcto.svg" id="imgCorrecto" alt="" />
            <p class="alert-success-text">La firma de documentos ya ha sido realizada.</p>
          </div>
          <div class="left-hero">
            <img class="hero-photo" src="../../assets/img/documentoFirmado.svg" alt="Documento firmado" />
          </div>
        </div>
  
        <div class="steps-bar">
          <p class="steps-bar-heading">A continuación puedes descargar tu documento firmado</p>
          <ol id="barra-simples-1" class="small step-progress-bar step-progress-bar-completed">
            <li class="step-present" style="width: 33.3333%; z-index: 3;">
              <span class="content-bullet">1</span>
              <div id="img1"><img id="F1" src="../../assets/img/paso-terminos.svg"></div>
              <span class="content-wrapper">Lectura de términos<br>y condiciones</span>
            </li>
            <li class="step-present" style="width: 33.3333%; z-index: 2;">
              <span class="content-bullet">2</span>
              <div id="img2"><img id="F2" src="../../assets/img/paso-lectura.svg"></div>
              <span class="content-wrapper">Lectura de<br> documento</span>
            </li>
            <li class="step-present" style="width: 33.3333%; z-index: 1;">
              <span class="content-bullet content-bullet-completed">3</span>
              <div id="img3"><img id="F3" src="../../assets/img/paso-identidad-ok.svg"></div>
              <span class="content-wrapper content-wrapper-completed">Validación de identidad <br>y firma de documentos</span>
            </li>
          </ol>
        </div>
  
        <div class="left-body">
          <div class="aceptacion d-none d-lg-block">
            Tu aceptación es equivalente a la firma en el acuerdo, según lo establecido por la Ley No. 527 de 1999,
            mediante la cual se define y regula el acceso y uso de los mensajes de datos. No es necesario imprimir o
            descargar los documentos.
          </div>
          <div id="boton" class="d-none d-lg-block">
            <button (click)="downloadPdf()" class="bFirma1">Descargar documento</button>
          </div>
        </div>
  
        <div class="left-footer">
          <div class="footer-grid">
            <img class="footer-logo" src="../../assets/img/LogoPestana.svg" alt="Apertú" />
            <div class="footer-col"><h6>Línea atención Bogotá</h6><p>(601) 744 2484</p></div>
            <div class="footer-col"><h6>Línea gratuita nacional</h6><p>018000 113 881</p></div>
            <div class="footer-col">
              <h6>Síguenos</h6>
              <div class="footer-social">
                <a href="https://www.facebook.com/share/1CaC2yg8Ju/?mibextid=wwXIfr" aria-label="Facebook"><img src="../../assets/img/facebook.svg" alt="" /></a>
                <a href="https://www.instagram.com/bayportcolombia?igsh=b3o1Mmt2bXd6Yno0" aria-label="Instagram"><img src="../../assets/img/instagram.svg" alt="" /></a>
                <a href="https://youtube.com/@bayportcolombiaoficial?si=oVOP0Gmuy5e-Cw-x" aria-label="YouTube"><img src="../../assets/img/youtube.svg" alt="" /></a>
                <a href="https://www.linkedin.com/company/bayportcolombia/" aria-label="LinkedIn"><img src="../../assets/img/LinkedIn.svg" alt="" /></a>
                <a href="https://x.com/bayportcolombia?s=21" aria-label="X"><img src="../../assets/img/x.svg" alt="" /></a>
              </div>
            </div>
          </div>
          <p class="footer-disclaimer">Las llamadas desde celular deben realizarse a la línea de atención en Bogotá. 
                                       Las llamadas desde teléfono fijo fuera de Bogotá, deben realizarse a la línea de atención nacional.</p>
        </div>
        <div class="left-footer-legal">
          <p class="footer-url">www.apertu.com.co</p>
          <p class="footer-copy">© Apertú Colombia S.A. Todos los derechos reservados</p>
        </div>
        </div>
  
        <div class="row d-block d-lg-none" style="padding: 12px 24px 20px;">
          <div class="col-md-12">
            <div class="aceptacion">
              Tu aceptación es equivalente a la firma en el acuerdo, según lo establecido por la Ley No. 527 de 1999,
              mediante la cual se define y regula el acceso y uso de los mensajes de datos. No es necesario imprimir o
              descargar los documentos.
            </div>
          </div>
          <div class="col-md-12" id="boton">
            <br>
            <button (click)="downloadPdf()" class="bFirma1">Descargar documento</button>
          </div>
        </div>
      </div>
  
      <!-- Panel derecho PDF — SIN CAMBIOS -->
      <div class="col-xs-12 col-md-7" *ngIf="estado == 3 && src2 != ''">
        <div id="outerContainer">
          <div class="pdf-container">
            <pdf-viewer [src]="src" [rotation]="4" [original-size]="false" [show-all]="true" [fit-to-page]="true"
              [zoom]="0" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
              [external-link-target]="'blank'" [autoresize]="true" [show-borders]="true"
              style="width: 100%; height: 100%;"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>
  
  </div>